import React from 'react';

/**
 * Reusable stat/metric card.
 *
 * Phase 2 upgrade: now a luminous glass tile with soft inner top sheen, a
 * large Outfit-font value, and an uppercase mono label. Optional `color`
 * overrides the value tint so callers (ReportsPage avg/best/low) can band.
 * `trend` (optional) renders a small delta chip under the value.
 */
export function MetricCard({ label, value, color = '', trend = null, className = '' }) {
  return (
    <div
      className={`liquid-card liquid-lift !p-4 relative overflow-hidden ${className}`}
      data-testid={`stat-${label.toLowerCase().replace(/\s/g, '-')}`}
    >
      {/* Inner radial accent for visual depth */}
      <div
        className="absolute -top-8 -right-8 w-24 h-24 rounded-full pointer-events-none opacity-[0.12]"
        style={{ background: 'radial-gradient(circle, hsl(var(--accent-cyan)) 0%, transparent 70%)' }}
        aria-hidden
      />
      <p className="text-[10px] font-mono text-ink-muted uppercase tracking-[0.22em] relative z-10">{label}</p>
      <p
        className={`mt-1.5 text-3xl font-light tracking-tighter relative z-10 ${color || 'text-ink'}`}
        style={{ fontFamily: 'Outfit, sans-serif' }}
      >
        {value}
      </p>
      {trend != null && (
        <div className="mt-2 relative z-10">{trend}</div>
      )}
    </div>
  );
}
